import { SET_TIMESHEET_VIEW } from '@/store/action-types';
import type { TimesheetView } from '@/timesheets/util/view';

export default function setTimesheetView(view: TimesheetView) {
  return {
    type: SET_TIMESHEET_VIEW,
    payload: view,
  };
}
